import useSWRMutation from "swr/mutation";
import { ServicesURL, downloadBlobFile, getQueryString } from "@utils/utilsApi";
import { MethodType } from "src/services/type";

interface DownloadEditionEnrolledUsersArgs {
  corporateId: string | number;
  editionId: string | number;
  totalItems: number;
  fieldFilters?: Record<string, any>;
}

const withoutEmptyValues = (
  fieldFilters?: Record<string, any>,
): Record<string, any> =>
  Object.fromEntries(
    Object.entries(fieldFilters || {}).filter(
      ([, value]) => value !== null && value !== undefined && value !== "",
    ),
  );

export const useDownloadEditionEnrolledUsers = () => {
  const { trigger, isMutating } = useSWRMutation(
    ServicesURL.downloadEnrolledEdition,
    (url: string, { arg }: { arg: DownloadEditionEnrolledUsersArgs }) =>
      downloadBlobFile(
        getQueryString(url, {
          ...withoutEmptyValues(arg.fieldFilters),
          corporateId: String(arg.corporateId),
          editionId: String(arg.editionId),
          pageIndex: "0",
          pageSize: String(Math.max(arg.totalItems, 1)),
        }),
        null,
        `users_subscribed_edition_${arg.editionId}.csv`,
        MethodType.GET,
      ),
    { onError: () => {} },
  );

  return { downloadEnrolledUsers: trigger, isDownloading: isMutating };
};
